<template>
  <div class="AllProduct">
    <!-- <SequenceBanner /> -->
    <div class="container center pt-4 h4 text-black lh-base">
      <p v-html="$t('allProduct.title')"></p>
    </div> 
    <div class="container center" style="height: 20px; background-color: white">
      <div class="h-25" style="width: 50px; background-color: #5fa4b8"></div>
    </div>
    <div class="all-product-intro container center pt-4 lh-lg text-dark-gray">
      <p v-html="$t('allProduct.tsk')"></p>
    </div> 
    <div class="container center pt-4 h4 text-primary lh-base">
      <p v-html="$t('allProduct.title2')"></p>
    </div> 
    <!--<div class="container">
        <img src="@/assets/images/product1.png" class="img-fluid"/>
    </div> -->
     <NeedleSpread />
    <div class="overlay-header">
      <p>PREMIUM SPECIALTY NEEDLES</p>
    </div>
    <ApplicationDomains />
    <div id="product" class="bg-light">
      <div class="container p-5">
        <div class="container center pt-4 h4 text-primary lh-base">
          <p v-html="$t('allProduct.title3')"></p>
        </div> 
        <div class="row justify-content-center gy-4">
          <div class="col-12 col-md-6 col-lg-6" v-for="(p, index) in product" :key="index">
            <router-link :to="'/product/' + p.name" class="text-decoration-none text-dark" style="display: block; height: 100%;">
              <div
                class="product-card shadow-sm p-3 mb-5 bg-white rounded"
                :style="cardStyles[index]"
                @mousemove="handleMouseMove($event, index)"
                @mouseleave="handleMouseLeave(index)"
              >
                <div style="text-align: center;">
                  <img class="img-sm" :src="p.src"/>
                </div>
                <div class="product-description mt-3">
                  <p class="product-title" v-html="p.usDesc"></p>
                  <p
                    v-if="!isEnglish"
                    class="product-title"
                    v-html="$t(`${p.name}.name`)"
                  ></p>
                  <p class="product-desc" v-html="$t(`${p.name}.shortDesc`)"></p>
                  <span class="mt-auto fw-bold text-decoration-none view-more">
                    VIEW ALL <i class="fa-solid fa-angles-right"></i>
                  </span>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div> 
    <!-- 聯絡我們 -->
    <ContactFooter/>
  </div>
</template>

<script>
import NeedleSpread from '@/components/NeedleSpread.vue'
import ApplicationDomains from '@/components/ApplicationDomains.vue'
//import SequenceBanner from '@/components/SequenceBanner.vue'
import ContactFooter from '@/components/ContactFooter.vue'
import product from "@/config/product.js";
export default {
  name: "AllProduct",
  components: {
    //SequenceBanner,
    NeedleSpread,
    ApplicationDomains,
    ContactFooter
  },
  data() {
    return {
      product: product,
      // product: product.filter( //*hide*
      //   p => !['TskSelectNeedle', 'TSKSyringe'].includes(p.name)
      // ),
      cardStyles: []

    };
  },
  computed: {
    isEnglish() {
      return String(this.$i18n.locale || '').toLowerCase().startsWith('en')
    }
  },
  methods: {
  handleMouseMove(e, idx) {
    const card = e.currentTarget;
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const midX = rect.width / 2;
    const midY = rect.height / 2;
    const rotateY = ((x - midX) / midX) * 12;
    const rotateX = ((midY - y) / midY) * 12;
    // 直接修改陣列（觸發 reactive）
    const styles = [...this.cardStyles];
    styles[idx] = {
      transform: `perspective(600px) rotateY(${rotateY}deg) rotateX(${rotateX}deg) scale(1.03)`,
      transition: 'transform 0.12s cubic-bezier(.25,.8,.25,1)'
    };
    this.cardStyles = styles;
  },
  handleMouseLeave(idx) {
    const styles = [...this.cardStyles];
    styles[idx] = {
      transform: 'perspective(600px) rotateY(0deg) rotateX(0deg) scale(1)',
      transition: 'transform 0.3s cubic-bezier(.25,.8,.25,1)'
    };
    this.cardStyles = styles;
  },
},
  mounted() {
    // 初始化
    this.cardStyles = this.product.map(() => ({
      transform: 'perspective(600px) rotateY(0deg) rotateX(0deg) scale(1)',
      transition: 'transform 0.3s cubic-bezier(.25,.8,.25,1)'
    }));
  }
};
</script>

<style scoped>
.AllProduct {
  padding-top: 0;
}
.all-product-intro {
  width: 60%;
  font-size: 16px;
}
.all-product-intro p {
  width: 100%;
  min-width: 0;
  overflow-wrap: anywhere;
}
.product-card {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: white;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  height: 100%;
  will-change: transform;
  cursor: pointer;
  transition: box-shadow 0.15s;
}
.product-card:hover {
  box-shadow: 0 10px 32px rgba(0,0,0,0.18);
}

.product-description {
  text-align: center;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
}

.product-description p.product-title {
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: bold;
  color: #5fa4b8;
}

.product-description p.product-desc {
  margin: 10px 0 15px;
  font-size: 14px;
  color: #707070;
  line-height: 1.5;
}

.product-description .view-more {
  color: #5fa4b8 !important;
}

.overlay-header {
  height: 60px;
  background: linear-gradient(to right, #137bba, #5fa4b8);
  color: white;
  text-align: center;
  padding: 1rem;
  margin-top: -50px;
  position: relative;
  z-index: 2;
}
@media (max-width: 576px) {
  .all-product-intro {
    width: 90%;
  }
  .product-card {
    height: auto;
  }
  .product-description p {
    white-space: normal;
    text-overflow: clip;
  }
}
</style>
